export const actionTypes = {
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
  SET_USER: "SET USER",
  SET_ORGANIZATION: "SET ORGANIZATION",
  SET_FCMTOKEN: "SET FCMTOKEN",
  SET_AUTHENTICATED: "SET AUTHENTICATED",
  SET_ROLES: "SET ROLES",
  SET_ALL_ORGANIZATIONS: "SET ALL ORGANIZATIONS",
  SET_CURRENT_TRACKING: "SET CURRENT TRACKING",
  SET_CUSTOMER_OF: "SET CUSTOMER OF",
  SET_PORTAL_CUSTOMER: "SET PORTAL CUSTOMER",
};

export const actions = {
  login: (data) => ({
    type: actionTypes.LOGIN,
    payload: data,
  }),
  logout: () => ({
    type: actionTypes.LOGOUT,
    payload: null,
  }),
  setUser: (user) => ({
    type: actionTypes.SET_USER,
    payload: user,
  }),
  setFcmToken: (token) => ({
    type: actionTypes.SET_FCMTOKEN,
    payload: token,
  }),
  setOrganization: (org) => ({
    type: actionTypes.SET_ORGANIZATION,
    payload: org,
  }),
  setAllOrganizations: (orgs) => ({
    type: actionTypes.SET_ALL_ORGANIZATIONS,
    payload: orgs,
  }),
  /* سازمان‌هایی که این شماره در آن‌ها «مشتری» است — کنار سازمان‌هایی که عضوشان
     است. صفحه‌ی ورود چیزی نمی‌پرسد؛ فقط فهرست فضاهای کاری بعد از ورود فرق می‌کند. */
  setCustomerOf: (memberships) => ({
    type: actionTypes.SET_CUSTOMER_OF,
    payload: memberships,
  }),
  /* عضویت مشتریِ انتخاب‌شده. تا وقتی پر باشد، اپ در حالت پرتال است. */
  setPortalCustomer: (membership) => ({
    type: actionTypes.SET_PORTAL_CUSTOMER,
    payload: membership,
  }),
  setAuthenticated: (state) => ({
    type: actionTypes.SET_AUTHENTICATED,
    payload: state,
  }),
  setRoles: (roles) => ({
    type: actionTypes.SET_ROLES,
    payload: roles,
  }),
  /**
   * Patches only the running timer on the signed-in user. Going through
   * `setUser` for this meant every caller had to spread a `user` snapshot it had
   * closed over, so a stale snapshot could resurrect a stopped timer — or an
   * unrelated profile update could silently drop a running one.
   */
  setCurrentTracking: (record) => ({
    type: actionTypes.SET_CURRENT_TRACKING,
    payload: record,
  }),
};
